import endOfWeek from '../endOfWeek/index.js'
import cloneObject from '../_lib/cloneObject/index.js'

/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the end of an ISO week
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
export default function endOfISOWeek (dirtyDate, dirtyOptions) {
  var endOfWeekOptions = cloneObject(dirtyOptions)
  endOfWeekOptions.weekStartsOn = 1
  return endOfWeek(dirtyDate, endOfWeekOptions)
}



//////////////////
// WEBPACK FOOTER
// ../~/date-fns/esm/endOfISOWeek/index.js
// module id = 894
// module chunks = 0